<template>
  <div class="file-upload">
    <div :class="`drop-zone-element drop-zone-${fileTypeName}`">
      <div class="text-wrapper">
        <p><span>+</span>Upload {{ fileTypeName }} File</p>
        <p class="drop-text">Drop file here to upload</p>
      </div>
    </div>
    <KendoFileUpload :api="api" :fileTypeName="fileTypeName"></KendoFileUpload>
  </div>
</template>

<script>
import '@progress/kendo-ui/js/kendo.core';
import '@progress/kendo-ui/js/kendo.upload';
import { UploadInstaller } from '@progress/kendo-upload-vue-wrapper';
import Vue from 'vue';
import Constants from '../../constants/constants';

Vue.use(UploadInstaller);

const KendoFileUpload = Vue.component('KendoFileUpload', {
  name: 'KendoFileUpload',
  template: `
    <kendo-upload
      ref="upload"
      name="files"
      :async-save-url="api"
      :validation-allowed-extensions="['.csv', '.txt', '.xls']"
      :show-file-list="false"
      :drop-zone="'.drop-zone-' + fileTypeName"
      @success="onSuccess"
      @error="onError">
    </kendo-upload>
  </div>`,
  methods: {
    getFileInfo(e) {
      return $.map(e.files, function (file) {
        let info = file.name;

        // File size is not available in all browsers
        if (file.size > 0) {
          info += ` (${Math.ceil(file.size / 1024)} KB)`;
        }
        return info;
      }).join(', ');
    },
    onSuccess(e) {
      alert(`Successfully uploaded and imported ${this.getFileInfo(e)}`);
    },
    onError(e) {
      alert(`Error attempting to ${e.operation} ${this.getFileInfo(e)}`);
    },
  },
  props: {
    api: {
      type: String,
      required: true,
    },
    fileTypeName: {
      type: String,
      required: true,
    },
  },
});

export default {
  name: 'FileUpload',
  components: {
    KendoFileUpload,
  },
  props: {
    api: {
      type: String,
      required: true,
    },
    fileTypeName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.file-upload {
  margin: 30px auto;
  max-width: 500px;

  .drop-zone-element {
    background-color: #f8f8f8;
    border: 1px solid #c7c7c7;
    display: inline-block;
    height: 110px;
    position: relative;
    text-align: center;
    width: 100%;
  }

  .text-wrapper {
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24px;
    line-height: 1.2em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }

  .drop-text {
    color: #c7c7c7;
    font-size: 12px;
    text-transform: uppercase;
  }

  .wrapper::after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
}
</style>
